export const RequiredInput = () => {
  return <div className="text-destructive">*</div>;
};
